export const reduxKey = '@@entities';

//# sourceMappingURL=constants.js.map